import { jsx as r } from "react/jsx-runtime";
import { Button as m } from "./styles.js";
import { Tooltip as p } from "../Tooltip/Tooltip.js";
const s = ({
  label: o,
  value: e,
  selected: t = !1,
  onChange: i,
  children: l
}) => /* @__PURE__ */ r(p, { tooltip: o, children: /* @__PURE__ */ r(
  m,
  {
    "aria-selected": t,
    $selected: t,
    onClick: () => i && i(e),
    "aria-label": o,
    children: l
  }
) });
export {
  s as ViewButton
};
//# sourceMappingURL=ViewButton.js.map
